import { render, staticRenderFns } from "./ConsultaDeTitulos.vue?vue&type=template&id=32e36dcc&scoped=true"
import script from "./ConsultaDeTitulos.vue?vue&type=script&lang=js"
export * from "./ConsultaDeTitulos.vue?vue&type=script&lang=js"
import style0 from "./ConsultaDeTitulos.vue?vue&type=style&index=0&id=32e36dcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e36dcc",
  null
  
)

export default component.exports